<template>
  <v-container fluid class="inventoryjournal-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/inventoryjournal/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="findInventoryJournalDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_journals.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/inventory/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Inventory
              </v-btn>
              <v-btn to="/inventorycount/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Counts
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="dataSelected"
              loading-text="Loading... Please wait"
              class="inventoryjournals-table"
              sort-by="journalnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_journals"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Inventory Journal?
                    </v-card-title>
                    <v-card-text>
                      {{ deleteinventoryjournal.journalnum }} 
                      {{ deleteinventoryjournal.journalname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteinventoryjournal)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.journalimage="{ item }">
                    <v-img
                    v-if="item.journalimage" 
                    v-bind:src="item.journalimage"
                    max-height="100"
                    max-width="100"
                  ></v-img>
              </template>
              <template v-slot:item.journalnum="{ item }">
                <p class="two-line"><b>{{ item.journalsubtype  }}</b></p>
                <p class="two-line">{{ item.journaltype  }}</p>
                <p class="two-line">{{ item.journalnum  }}</p>
                <p v-if="item.journaldate!=undefined" class="two-line">{{ new Date(item.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.journalname="{ item }">
                <p class="two-line">{{ item.journalname }}</p>
                <p class="two-line" v-if="item.locationid!=undefined">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
              </template>
              <template v-slot:item.journalstatus="{ item }">
                <v-chip
                  v-if="item.journalstatus!=undefined"
                  :color="item.journalstatus=='New' ? 'primaryConst white--text' : item.journalstatus=='Completed' ? 'successConst white--text' : item.journalstatus=='Credit' ? 'orangeConst white--text' : item.journalstatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.journalstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <!-- <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                <v-btn v-if="item.journalstatus=='New' && item.journaltype=='Inventory Journal'" icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.journalstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findInventoryJournalDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Inventory Journals</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['Inventory Journal', 'System Journal']"
                  v-model="find_query.journaltype"
                  label="Journal Type"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['Sales Orders', 'Purchase Receipt', 'Inventory Transfer', 'Inventory Adjustment']"
                  v-model="find_query.journalsubtype"
                  label="Journal Subtype"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  class="mb-4"
                  type="number"
                  placeholder="Journal Num"
                  v-model="find_query.journalnum"
                  dense
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line hint="Journal Num">
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="find_query.locationid"
                  label="Location"
                  dense
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findInventoryJournalDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetInventoryJournals"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findInventoryJournals"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'InventoryJournalList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      findInventoryJournalDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      deleteinventoryjournal: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'journalimage', sortable: false, width: "8%" },
        { text: 'Journal', value: 'journalnum', sortable: false, width: "20%" },
        { text: 'Name & Location', value: 'journalname' },
        { text: 'Create By', value: 'userid', width: "15%" },
        { text: 'Status', value: 'journalstatus', width: "10%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      data_journals: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('InventoryJournal', ['inventoryjournals', 'isReceiving', 'isDeleting', 'idToDelete', 'inventoryjournalsMessage', 'isUpdating']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Location', ['locations']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('InventoryJournal', ["getInventoryJournalsRequest", "findInventoryJournalsRequest", "deleteInventoryJournalRequest","updateInventoryJournalRequest","createInventoryJournalRequest"]),
    ...mapActions('PayMethod', ["getPayMethodsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_journals.map(order=>{return {
        ordernum: order.journalnum, 
        orderdate: order.journaldate!=undefined ? new Date(order.journaldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.journaldate!=undefined ? new Date(order.journaldate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.journaltype,
        name: order.journalname, 
        address: order.inventoryjournaladdress,
        location: order.locationid!=undefined && this.locations.length>0 ? this.locations.find(location=>location._id == order.locationid)['locationname'] : '',
        township: order.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == order.townshipid)['townshipname'] : '',
        customertype: order.customertype,
        salesrep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.inventoryjournaltaxamount,
        subtotal: order.inventoryjournalsubtotal,
        total: order.inventoryjournaltotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.journalstatus=='Completed')!=null) return false;
      return true;
    },
    checkInventoryJournals(){
      return this.dataSelected.filter(item=>item.journalstatus=='Completed').map(item=>item.journalnum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'InventoryJournalEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'InventoryJournalPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InventoryJournalView', params: item });
    },
    async findInventoryJournals(){
      this.findInventoryJournalDialog = false;
      if(Object.keys(this.find_query).length==0){
        await this.getInventoryJournalsRequest();
        this.data_journals = Object.assign([], this.inventoryjournals);
      }
      else{
        let result = await this.findInventoryJournalsRequest(this.find_query);
        this.data_journals = Object.assign([], result);
      }
    },
    async resetInventoryJournals(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteInventoryJournalRequest({_id: item._id});
      this.data_journals = this.inventoryjournals;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteinventoryjournal = {
        _id: item._id,
        journalnum: item.journalnum,
        journalname: item.journalname,
      }
    },
  },
  async created () {
    if(this.inventoryjournals.length==0) await this.getInventoryJournalsRequest();
    this.data_journals = Object.assign([], this.inventoryjournals);

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
